/**
 * External dependencies
 */
 import inherits from 'inherits';

 export default class CurrentBarcodeLookup {
     constructor(cscom) {
         if (!(this instanceof CurrentBarcodeLookup)) {
             return new CurrentBarcodeLookup(cscom);
         }
         this.cscom = cscom;
     }
 
     get(data) {
        return this.cscom.req.get('/customer-site-api/barcode-lookup-plans/view', null, data);
    }  
 }
 